import app from 'app';
import templateUrl from './submitClaimVerifyBill.html';

import { logEvent, eventCategories } from 'helpers/analytics';

import _ from 'lodash';

function SubmitClaimVerifyBill() {
  const SubmitClaimVerifyBill = this;

  SubmitClaimVerifyBill.back = function() {
    SubmitClaimVerifyBill.page = 'medical';
  };

  SubmitClaimVerifyBill.next = function() {
    if (SubmitClaimVerifyBill.billInfoComplete) {
      logEvent('MSOONstepCompleted', {
        category: eventCategories.MSOON,
        stepName: 'verify your bill'
      });
      SubmitClaimVerifyBill.page = 'medical_upload_bill';
    } else {
      SubmitClaimVerifyBill.page = 'incomplete_bill';
    }
  };

  SubmitClaimVerifyBill.hasUnansweredQuestions = function() {
    return _.isUndefined(SubmitClaimVerifyBill.billInfoComplete);
  };

  SubmitClaimVerifyBill.$onInit = function() {
    SubmitClaimVerifyBill.yesNoOptions = [
      {
        label: 'Yes',
        value: true
      },
      {
        label: 'No',
        value: false
      }
    ];
  };
}

app.component('submitClaimVerifyBill', {
  bindings: {
    page: '=',
    billInfoComplete: '='
  },
  controller: SubmitClaimVerifyBill,
  controllerAs: 'SubmitClaimVerifyBill',
  templateUrl
});

export default 'submitClaimVerifyBill';
